import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import deliveringActions from '../../actions/DeliveringActions';
import fileDeliveryService from '../../services/FileDeliveryService';
import fileDeliveryUploader from '../../services/FileDeliveryUploader';
import storeManager from '../../store/StoreManager';
import { t } from '../../services/i18nService';

import styles from './testOverview.scss';
import navigationService from '../../services/NavigationService';
import sessionReader from '../../store/readHelpers/SessionReader';
import apiReader from '../../store/readHelpers/ApiReader';

const { DOWNLOADED, ERRORED } = deliveringActions.statuses;

const fileBlobForDownload = {};

function getFirstPendingFileDownloadLink(deliveryObject) {
    if (fileBlobForDownload[deliveryObject.assessmentRunId]) {
        return fileBlobForDownload[deliveryObject.assessmentRunId];
    }
    const fileContents = fileDeliveryService.getEncryptedFileContent(false, deliveryObject);
    fileBlobForDownload[deliveryObject.assessmentRunId] = fileDeliveryService.getFileBlobForLink(fileContents);
    return fileBlobForDownload[deliveryObject.assessmentRunId];
}

function getFirstPendingFileDownloadName(deliveryObject) {
    return fileDeliveryService.getFileName(deliveryObject.assessmentRunId);
}

let handle;

function PendingFileDeliveryStatus(props) {
    const { pendingFileDeliveries, isOnline } = props;
    const [isTimedOut, setIsTimedOut] = useState(false);
    const deliveryObject = pendingFileDeliveries[0];
    const deliveryObjectStatus = fileDeliveryUploader.getDeliveryStatusForAssessmentRunId(
        deliveryObject.assessmentRunId
    );

    const onSaveAndExit = () => {
        setTimeout(() => {
            fileDeliveryUploader.removeFromQueue(deliveryObject.assessmentRunId);
            delete fileBlobForDownload[deliveryObject.assessmentRunId];
            storeManager
                .getStore()
                .dispatch(
                    deliveringActions.setOfflineFileDeliveryStatus(deliveryObject.assessmentRunId, DOWNLOADED)
                );
            if (sessionReader.userHasSeb() || sessionReader.userHasIEP()) {
                navigationService.exitSeb();
            }
        }, 1000);
    };

    const getSaveAndExitSebButton = () => {
        return (
            <a
                className={`${styles.button} btn`}
                download={getFirstPendingFileDownloadName(deliveryObject)}
                href={getFirstPendingFileDownloadLink(deliveryObject)}
                onClick={onSaveAndExit}
                role="button"
            >
                {t('connectivity.exitSebNow')}
            </a>
        );
    };

    useEffect(() => {
        const onTimeout = () => {
            setIsTimedOut(true);
        };
        handle = setTimeout(onTimeout, 60000);

        return () => {
            clearTimeout(handle);
        };
    }, [true]);

    if (isOnline) {
        return false;
    }

    return (
        <div className={styles.connectivityBannerWrapper}>
            <div className={styles.connectivityBanner}>
                {
                    isTimedOut ?
                        <div
                            className={styles.connectivityBackground}
                        >
                            <h2>{t('connectivity.failed.title')}</h2>
                            <div dangerouslySetInnerHTML={{ __html: t('connectivity.failed.body') }} />
                            {getSaveAndExitSebButton()}
                        </div> :
                        <div
                            className={`${styles.connectivityBackground} reconnecting`}
                        >
                            {
                                deliveryObjectStatus === ERRORED && !apiReader.isServerOK()
                                    ? <React.Fragment>
                                        <h2>{t('connectivity.syncError.title')}</h2>
                                        <div dangerouslySetInnerHTML={{ __html: t('connectivity.syncError.body') }} />
                                        {getSaveAndExitSebButton()}
                                    </React.Fragment>
                                    : <React.Fragment>
                                        <h2>{t('connectivity.restoring.title')}</h2>
                                        <div dangerouslySetInnerHTML={{ __html: t('connectivity.restoring.body') }} />
                                    </React.Fragment>
                            }
                        </div>
                }
                <hr />
                <div className={styles.connectivityFooter} dangerouslySetInnerHTML={{ __html: t('connectivity.footer') }} />
            </div>
        </div>
    );
}

PendingFileDeliveryStatus.prototype.propTypes = {
    pendingFileDeliveries: PropTypes.array.isRequired,
    isOnline: PropTypes.bool.isRequired,
};

export default PendingFileDeliveryStatus;
